import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { NatureOfTreatmentService } from '../nature-of-treatment.service';
import { ToastrService } from 'ngx-toastr';
import { INatureOfTreatment } from '../inature-of-treatment';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-nature-of-treatment-detail',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './nature-of-treatment-detail.component.html',
  styleUrl: './nature-of-treatment-detail.component.scss'
})
export class NatureOfTreatmentDetailComponent {

  natureOfTreatmentForm: FormGroup;
  
  constructor(
    private _formbuilder: FormBuilder,
    private dialogRef: MatDialogRef<NatureOfTreatmentDetailComponent>,
    private toastr: ToastrService,
    private translate: TranslateService,
    private _natureOfTreatmentService: NatureOfTreatmentService,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { natureOfTreatment: INatureOfTreatment },
  ) {
  }

  ngOnInit(): void {
    this.natureOfTreatmentForm = this._formbuilder.group({
      name: [this._data?.natureOfTreatment?.name || '', [Validators.required, Validators.maxLength(100)]],
    })
  }

  onSaveNatureOfTreatment() {
    const data = this.natureOfTreatmentForm.getRawValue();
    this._natureOfTreatmentService.createNatureOfTreatment(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('LABEL.NATURE_OF_TREATMENT')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }

}
